import { render, staticRenderFns } from "./AddMapping.vue?vue&type=template&id=5a82527d&scoped=true"
import script from "./AddMapping.vue?vue&type=script&lang=js"
export * from "./AddMapping.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a82527d",
  null
  
)

export default component.exports